/** collection.js — auto-submit the facets form when the sort order changes. */
const sort = document.getElementById('SortBy');
if (sort && sort.form) {
  sort.addEventListener('change', () => {
    if (sort.form.requestSubmit) sort.form.requestSubmit();
    else sort.form.submit();
  });
}
